import { render, staticRenderFns } from "./HomeDashboardMobile.vue?vue&type=template&id=08006864&"
import script from "./HomeDashboardMobile.vue?vue&type=script&lang=ts&"
export * from "./HomeDashboardMobile.vue?vue&type=script&lang=ts&"
import style0 from "./HomeDashboardMobile.vue?vue&type=style&index=0&id=08006864&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports